"use strict";function startDocSign$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startDocSign$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.startDocSign";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.33"},_a)),exports.startDocSign$=startDocSign$,exports.default=startDocSign$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/startDocSign.js
// module id = 1029
// module chunks = 106